import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Input, Label } from "@cieda/djayma-ui";

interface TypedConfirmationProps {
  readonly expectedValue: string;
  readonly onMatch: (matched: boolean) => void;
}

/**
 * Requires the user to type an exact value to enable a destructive action.
 * Used by BulkDeleteModal when >= 10 items are selected.
 */
export function TypedConfirmation({
  expectedValue,
  onMatch,
}: TypedConfirmationProps) {
  const { t } = useTranslation("admin");
  const [input, setInput] = useState("");

  const handleChange = (value: string) => {
    setInput(value);
    onMatch(value.trim() === expectedValue);
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="typed-confirm">
        {t("products.bulk.typed_confirm_prompt")}
      </Label>
      <div className="flex items-center gap-2">
        <Input
          id="typed-confirm"
          value={input}
          onChange={(e) => handleChange(e.target.value)}
          placeholder=""
          className="max-w-[120px] tabular-nums"
          autoComplete="off"
          inputMode="numeric"
        />
        <span className="text-sm font-medium text-stone-500 tabular-nums">
          {expectedValue}
        </span>
      </div>
    </div>
  );
}
